
export enum CancelSupervisorReason {
    ColdTransfer = 0,
    WarmTransfer = 1,
    Park = 2,
    ColdTransferIvr = 3,
    WarmTransferIvr = 4
}

export class CancelSupervisorInvite {
    tenantId!: string;
    userId!: string;
    scenarioId?: string;
    reason!: CancelSupervisorReason;
}


